export default "__VITE_ASSET__72a4a1f3__"